$(function(){

  $('#slider').orbit({
    animation: 'horizontal-push',  // fade, horizontal-slide, vertical-slide, horizontal-push
    animationSpeed: 350,           // how fast animtions are
    timer: true,                   // true or false to have the timer
    advanceSpeed: 6500,            // if timer is enabled, time between transitions
    directionalNav: false,         // manual advancing directional navs
    captions: false,               // do you want captions?
    bullets: false,                // true or false to activate the bullet navigation
    fluid: '16x9',                 // or set a aspect ratio for content slides (ex: '4x3')
    afterLoadComplete: function(){
      var orbit = this;
      var thumbContainer = this.$element.parent().siblings('#slider-thumbs');
      var thumbs = thumbContainer.find('a');


      thumbs.each(function(i, t){
        $(t).click(function () {
          orbit.stopClock();
          if (orbit.options.resetTimerOnClick) {
            orbit.rotateTimer(true);
            orbit.startClock();
          }
          orbit.$element.trigger('orbit.goto', [i]);

          thumbs.removeClass('active');
          thumbs.eq([i]).addClass('active');

          return false;
        });
      });
    },
    afterSlideChange: function(){
      var orbit = this;
      var thumbContainer = this.$element.parent().siblings('#slider-thumbs');
      var thumbs = thumbContainer.find('a');

      thumbs.each(function(i, t){
        thumbs.removeClass('active');
        thumbs.eq(orbit.activeSlide).addClass('active');
      });
    }
  });

  // lazy load images
  $('.lazyimage img').css('visibility','hidden').each(function(){
    if (!this.complete) { // if image is NOT cached
      $(this).load(function(){
        $(this).css({'visibility':'visible','opacity':0}).animate({'opacity':1},400, function(){
        $(this).parents('.slide').css('position', 'absolute');
        });
      });
    } else { // if image is cached
      $(this).css({'visibility':'visible','opacity':0}).animate({'opacity':1},400, function(){
		$(this).parents('.slide').css('position', 'absolute');
      });
    }
  });



  // product: gallery images
  $('.cloud-zoom-gallery').each(function(i, elm){
    var image = new Image();
    image.src = $(elm).attr('href');
    $(image).load(function(){ });
  });

  // product: collection carousel
  $(".carousel").each(function(i, c){
    $(c).lemmonSlider();
  });

  // product: tabs
  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var target = $(this).attr('href');
      if (target.charAt(0)=="#") {
        tab.removeClass('active');
        $(this).addClass('active');
        $(target).show().addClass('active').siblings().hide().removeClass('active');
        return false;
      }
    });
  });

  // blog: link images to article
  var b_img = $('#blog-posts').find('img');
  b_img.wrap(function(){
    return '<div class="img_wrap"><a href="'+b_img.parents('article').data('href')+'" title=""></a></div>';
  });

  // cart: remove from cart
  $('.remove-from-cart').click(function(){
    var parent = $(this).parents('.item');
    var href   = $(this).attr('href');
    parent.animate({opacity: 0.4},200);
    // return false;
  });
  
  // account:
  $('#recover-password-handle a').click(function(){
    $('#recover-password').toggleClass('hide');
  });
  
  // init external scripts
  $(document).ready(function() {
    _myDocumentReady.init();
  });

});



var _myDocumentReady = {
  init: function() {
    // this._loadTwitter();
    this._loadShareThis();
  },
  _loadTwitter: function(){
    if($('#twitter-feed').length) {
      $.getScript('http://widgets.twimg.com/j/2/widget.js', function(){
        new TWTR.Widget({
          id: 'twitter-widget-wrapper', version: 3, type: 'profile', rpp: 1, interval: 30000, width: 'auto', height: 300,
          theme: {
            shell: {background:'#FFFFFF',color:'#898989'},
            tweets: {background:'#FFFFFF',color:'#898989',links:'#01323F'}
          },
          features: {scrollbar:false,loop:true,live:false,behavior:'default'}
        }).render().setUser('misseeeuk').start();
      });
    }
  },
  _loadShareThis: function(){
    var switchTo5x = true;
    var __st_loadLate = true;
    $.getScript('http://w.sharethis.com/button/buttons.js', function(){
      stLight.options({publisher: "fa2bb35f-61ff-4587-acf7-a6bd12c51781"});
      $('#social').find('small').css('display','none');
    });
  }
};